import { render, staticRenderFns } from "./Politics.vue?vue&type=template&id=757ffb9e&"
import script from "./Politics.vue?vue&type=script&lang=js&"
export * from "./Politics.vue?vue&type=script&lang=js&"
import style0 from "./Politics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports